export default "__VITE_ASSET__CtlXMXfe__"